"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTick = void 0;
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveObjectsData_1 = require("@dive/entities/diveObjectsData");
var diveTilemapUtils_sidecar_1 = require("@dive/tilemap/diveTilemapUtils-sidecar");
var diveAi_common_sidecar_1 = require("./diveAi_common-sidecar");
var enumsAi_1 = require("./enumsAi");
function updateTick(obj) {
    // Check for wakeness
    if (!obj.isAwake) {
        if (obj.tile) {
            if (diveTilemapUtils_sidecar_1.diveTilemapUtils.wasSpotVisibleToHero(obj.tile)) {
                obj.isAwake = true;
            }
        }
        return;
    }
    // Do we have any abilities?
    var enemyState = obj.enemyState;
    if (enemyState) {
        // TODO: do this if not moving and reloaded, and not attacking
        var d = enemyState.data;
        // TODO: move to generic handle abilities ai
        if (d.abilities.length > 0) {
            enemyState.abilityTimerTicks++;
            if (diveDebug_sidecar_1.diveDebug.debug_fastEnemyAbilities) {
                enemyState.abilityTimerTicks += 9;
            }
            if (enemyState.abilityTimerTicks > d.maxAbilityTicksTime) {
                enemyState.abilityTimerTicks = 0;
                var ability = obj.rando.sample(d.abilities);
                if (ability === enumsAi_1.EAiAbility.SpawnSpiderWeb) {
                    diveAi_common_sidecar_1.diveAi_common.trySpawnObjectNextTo(obj, diveObjectsData_1.EDiveObjectType.SpiderWeb, true, true);
                }
                if (ability === enumsAi_1.EAiAbility.SpawnSpiderEgg) {
                    diveAi_common_sidecar_1.diveAi_common.trySpawnObjectNextTo(obj, diveObjectsData_1.EDiveObjectType.SpiderEgg, false, true);
                }
                return;
            }
        }
    }
    if (obj.pathResult) {
        // Still moving
        return;
    }
    if (obj.ai.state === enumsAi_1.EAiState.FleeBasic) {
        diveAi_common_sidecar_1.diveAi_common.doFleeBasic(obj);
        return;
    }
    // Find nearest target
    var target = diveAi_common_sidecar_1.diveAi_common.findNearestOrPreferredTarget(obj, {
        type: enumsAi_1.EAiTargetType.Hero,
        range: 7,
        requireVision: true,
        requireAlive: true,
        requireLineOfFire: true,
    });
    // Move off if too many units here
    if (diveAi_common_sidecar_1.diveAi_common.moveOffIfTooManyUnitsHere(obj, target)) {
        return;
    }
    if (target) {
        diveAi_common_sidecar_1.diveAi_common.doSeekTarget_MeleeBasic(obj, target);
    }
    else {
        // Wait
        if (obj.rando.chance(0.75)) {
            return;
        }
        diveAi_common_sidecar_1.diveAi_common.doWanderBasic(obj);
    }
}
exports.updateTick = updateTick;
